import { combineReducers } from "@reduxjs/toolkit";
import pageNotFoundReducer from "./pageNotFoundReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const rootReducers = combineReducers({
  pageNotFound: pageNotFoundReducer,
});
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducers);
export default persistedReducer;
